import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["REMINDER"] = "REMINDER";
    InvoiceState["OVERDUE"] = "OVERDUE";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["CANCELED"] = "CANCELED";
})(InvoiceState || (InvoiceState = {}));
export var ScreenshotStatus;
(function (ScreenshotStatus) {
    ScreenshotStatus["NEW"] = "NEW";
    ScreenshotStatus["UPLOADED"] = "UPLOADED";
    ScreenshotStatus["SENT"] = "SENT";
    ScreenshotStatus["HIDDEN"] = "HIDDEN";
})(ScreenshotStatus || (ScreenshotStatus = {}));
export var CreativeStatus;
(function (CreativeStatus) {
    CreativeStatus["ACTIVE"] = "ACTIVE";
    CreativeStatus["INACTIVE"] = "INACTIVE";
})(CreativeStatus || (CreativeStatus = {}));
export var CreativeFlag;
(function (CreativeFlag) {
    CreativeFlag["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CreativeFlag["APPROVED"] = "APPROVED";
    CreativeFlag["REJECTED"] = "REJECTED";
})(CreativeFlag || (CreativeFlag = {}));
export var CreativeType;
(function (CreativeType) {
    CreativeType["NATIVE"] = "NATIVE";
    CreativeType["NATIVE_VIDEO"] = "NATIVE_VIDEO";
})(CreativeType || (CreativeType = {}));
export var ImageType;
(function (ImageType) {
    ImageType["NATIVE16X9"] = "NATIVE16X9";
    ImageType["NATIVE1X1"] = "NATIVE1X1";
})(ImageType || (ImageType = {}));
export var Product;
(function (Product) {
    Product["YALEO_NATIVE_ADD"] = "YALEO_NATIVE_ADD";
    Product["YALEO_INTERACTIVE_STORIES"] = "YALEO_INTERACTIVE_STORIES";
    Product["YALEO_VIDEO_ADD"] = "YALEO_VIDEO_ADD";
})(Product || (Product = {}));
export var Goal;
(function (Goal) {
    Goal["INTEREST_TRAFFIC"] = "INTEREST_TRAFFIC";
    Goal["ENGAGEMENT"] = "ENGAGEMENT";
    Goal["LEADS"] = "LEADS";
})(Goal || (Goal = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MULTIDEVICE"] = "MULTIDEVICE";
})(DeviceType || (DeviceType = {}));
export var BillingType;
(function (BillingType) {
    BillingType["CPC"] = "CPC";
    BillingType["CPM"] = "CPM";
})(BillingType || (BillingType = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["EN"] = "EN";
    LanguageCode["DE"] = "DE";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var ReportExtension;
(function (ReportExtension) {
    ReportExtension["PDF"] = "PDF";
    ReportExtension["XLSX"] = "XLSX";
})(ReportExtension || (ReportExtension = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory["NO_CATEGORY"] = "NO_CATEGORY";
    EventCategory["LANDING_PAGE"] = "LANDING_PAGE";
    EventCategory["ITEM_VIEW"] = "ITEM_VIEW";
    EventCategory["ADD_TO_CART"] = "ADD_TO_CART";
    EventCategory["INITIATE_CHECKOUT"] = "INITIATE_CHECKOUT";
    EventCategory["ADD_PAYMENT_INFO"] = "ADD_PAYMENT_INFO";
    EventCategory["PURCHASE"] = "PURCHASE";
    EventCategory["LEAD"] = "LEAD";
})(EventCategory || (EventCategory = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["HYBRID_VIEW_CLICK"] = "HYBRID_VIEW_CLICK";
    TriggerType["VIEW"] = "VIEW";
    TriggerType["CLICK"] = "CLICK";
})(TriggerType || (TriggerType = {}));
export var IntervalType;
(function (IntervalType) {
    IntervalType["DAYS"] = "DAYS";
    IntervalType["HOURS"] = "HOURS";
    IntervalType["MINUTES"] = "MINUTES";
})(IntervalType || (IntervalType = {}));
export var RepeatConversions;
(function (RepeatConversions) {
    RepeatConversions["ONE_CONVERSION_PER_USER"] = "ONE_CONVERSION_PER_USER";
    RepeatConversions["ALL_CONVERSIONS_PER_USER"] = "ALL_CONVERSIONS_PER_USER";
    RepeatConversions["ONE_CONVERSION_PER_USER_EVERY"] = "ONE_CONVERSION_PER_USER_EVERY";
})(RepeatConversions || (RepeatConversions = {}));
export var PixelType;
(function (PixelType) {
    PixelType["IMAGE"] = "IMAGE";
    PixelType["JAVASCRIPT"] = "JAVASCRIPT";
})(PixelType || (PixelType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["BILLING_ADDRESS"] = "BILLING_ADDRESS";
})(PaymentMethod || (PaymentMethod = {}));
export var HistoryType;
(function (HistoryType) {
    HistoryType["CREATE"] = "CREATE";
    HistoryType["UPDATE"] = "UPDATE";
})(HistoryType || (HistoryType = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["INACTIVE"] = "INACTIVE";
    CampaignStatus["ACTIVE"] = "ACTIVE";
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignFlag;
(function (CampaignFlag) {
    CampaignFlag["PAYMENT_FAILED"] = "PAYMENT_FAILED";
})(CampaignFlag || (CampaignFlag = {}));
export var CampaignPositionStatus;
(function (CampaignPositionStatus) {
    CampaignPositionStatus["INACTIVE"] = "INACTIVE";
    CampaignPositionStatus["ACTIVE"] = "ACTIVE";
})(CampaignPositionStatus || (CampaignPositionStatus = {}));
export var CampaignPositionState;
(function (CampaignPositionState) {
    CampaignPositionState["EXPIRED"] = "EXPIRED";
    CampaignPositionState["RUNNING"] = "RUNNING";
})(CampaignPositionState || (CampaignPositionState = {}));
export var CampaignPositionFlag;
(function (CampaignPositionFlag) {
    CampaignPositionFlag["MISSING_CREATIVE"] = "MISSING_CREATIVE";
    CampaignPositionFlag["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignPositionFlag["REJECTED"] = "REJECTED";
    CampaignPositionFlag["CREATIVE_INACTIVE"] = "CREATIVE_INACTIVE";
})(CampaignPositionFlag || (CampaignPositionFlag = {}));
export var AdvertiserStatus;
(function (AdvertiserStatus) {
    AdvertiserStatus["INACTIVE"] = "INACTIVE";
    AdvertiserStatus["ACTIVE"] = "ACTIVE";
    AdvertiserStatus["ADMIN"] = "ADMIN";
})(AdvertiserStatus || (AdvertiserStatus = {}));
export var Flag;
(function (Flag) {
    Flag["MISSING_CREATIVES"] = "MISSING_CREATIVES";
    Flag["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    Flag["REJECTED"] = "REJECTED";
    Flag["CREATIVE_INACTIVE"] = "CREATIVE_INACTIVE";
    Flag["PAYMENT_UNSUCCESSFUL"] = "PAYMENT_UNSUCCESSFUL";
    Flag["MISSING_VALID_PAYMENT_METHOD"] = "MISSING_VALID_PAYMENT_METHOD";
})(Flag || (Flag = {}));
export var DocumentEntityType;
(function (DocumentEntityType) {
    DocumentEntityType["ADVERTISER"] = "ADVERTISER";
    DocumentEntityType["CAMPAIGN"] = "CAMPAIGN";
})(DocumentEntityType || (DocumentEntityType = {}));
export var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["ORDER"] = "ORDER";
    DocumentCategory["OFFER"] = "OFFER";
    DocumentCategory["CONFIRMATION"] = "CONFIRMATION";
    DocumentCategory["INVOICE"] = "INVOICE";
    DocumentCategory["CONTRACT"] = "CONTRACT";
    DocumentCategory["REPORT"] = "REPORT";
    DocumentCategory["OTHER"] = "OTHER";
})(DocumentCategory || (DocumentCategory = {}));
export var PayoutStatusDto;
(function (PayoutStatusDto) {
    PayoutStatusDto["PAID"] = "PAID";
    PayoutStatusDto["PENDING"] = "PENDING";
    PayoutStatusDto["IN_TRANSIT"] = "IN_TRANSIT";
    PayoutStatusDto["CANCELED"] = "CANCELED";
    PayoutStatusDto["FAILED"] = "FAILED";
})(PayoutStatusDto || (PayoutStatusDto = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["SUCCESSFUL"] = "SUCCESSFUL";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["REQUIRES_CAPTURE"] = "REQUIRES_CAPTURE";
    PaymentStatus["REFUND"] = "REFUND";
    PaymentStatus["PENDING_CHARGE_APPROVAL"] = "PENDING_CHARGE_APPROVAL";
    PaymentStatus["PENDING_DEPOSIT_APPROVAL"] = "PENDING_DEPOSIT_APPROVAL";
})(PaymentStatus || (PaymentStatus = {}));
export var InvoiceGenerationResponse;
(function (InvoiceGenerationResponse) {
    InvoiceGenerationResponse["REQUESTED"] = "REQUESTED";
    InvoiceGenerationResponse["SCHEDULED"] = "SCHEDULED";
})(InvoiceGenerationResponse || (InvoiceGenerationResponse = {}));
export var LanguageType;
(function (LanguageType) {
    LanguageType["ALL"] = "ALL";
    LanguageType["DE"] = "DE";
    LanguageType["IT"] = "IT";
    LanguageType["FR"] = "FR";
})(LanguageType || (LanguageType = {}));
export var CompanyFilterType;
(function (CompanyFilterType) {
    CompanyFilterType["CAMPAIGN"] = "CAMPAIGN";
    CompanyFilterType["CREATIVE"] = "CREATIVE";
    CompanyFilterType["ADVERTISER"] = "ADVERTISER";
})(CompanyFilterType || (CompanyFilterType = {}));
export var PaymentOperation;
(function (PaymentOperation) {
    PaymentOperation["TOP_UP"] = "TOP_UP";
    PaymentOperation["PAYMENT"] = "PAYMENT";
    PaymentOperation["REFUND"] = "REFUND";
})(PaymentOperation || (PaymentOperation = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["ACTIVATED_CAMPAIGN"] = "ACTIVATED_CAMPAIGN";
    ActivityType["CREDIT_CARD_PAYMENT_SUCCESSFUL"] = "CREDIT_CARD_PAYMENT_SUCCESSFUL";
    ActivityType["CREDIT_CARD_PAYMENT_FAILED"] = "CREDIT_CARD_PAYMENT_FAILED";
    ActivityType["INVOICE_SENT"] = "INVOICE_SENT";
    ActivityType["INVOICE_REMINDER_SENT"] = "INVOICE_REMINDER_SENT";
    ActivityType["INVOICE_OVERDUE_SENT"] = "INVOICE_OVERDUE_SENT";
    ActivityType["SCREENSHOT_SENT"] = "SCREENSHOT_SENT";
    ActivityType["ORDER_CONFIRMED_EMAIL_SENT"] = "ORDER_CONFIRMED_EMAIL_SENT";
    ActivityType["CAMPAIGN_FINISHED_EMAIL_SENT"] = "CAMPAIGN_FINISHED_EMAIL_SENT";
    ActivityType["CAMPAIGN_UNDERDELIVERING_EMAIL_SENT"] = "CAMPAIGN_UNDERDELIVERING_EMAIL_SENT";
    ActivityType["CAMPAIGN_COMMENT_NOTIFICATION_EMAIL_SENT"] = "CAMPAIGN_COMMENT_NOTIFICATION_EMAIL_SENT";
    ActivityType["CREATE_CREATIVE_PUSH_TO_XANDR"] = "CREATE_CREATIVE_PUSH_TO_XANDR";
    ActivityType["UPDATE_CREATIVE_PUSH_TO_XANDR"] = "UPDATE_CREATIVE_PUSH_TO_XANDR";
    ActivityType["UPDATE_CREATIVE_STATUS_PUSH_TO_XANDR"] = "UPDATE_CREATIVE_STATUS_PUSH_TO_XANDR";
    ActivityType["DEACTIVATE_CREATIVE_PUSH_TO_XANDR"] = "DEACTIVATE_CREATIVE_PUSH_TO_XANDR";
    ActivityType["CREATIVE_REJECTED"] = "CREATIVE_REJECTED";
    ActivityType["CREATE_LINE_ITEM_PUSH_TO_XANDR"] = "CREATE_LINE_ITEM_PUSH_TO_XANDR";
    ActivityType["UPDATE_LINE_ITEM_PUSH_TO_XANDR"] = "UPDATE_LINE_ITEM_PUSH_TO_XANDR";
    ActivityType["ACTIVATE_LINE_ITEM_PUSH_TO_XANDR"] = "ACTIVATE_LINE_ITEM_PUSH_TO_XANDR";
    ActivityType["DEACTIVATE_LINE_ITEM_PUSH_TO_XANDR"] = "DEACTIVATE_LINE_ITEM_PUSH_TO_XANDR";
    ActivityType["USE_EXISTING_LINE_ITEM_FROM_XANDR"] = "USE_EXISTING_LINE_ITEM_FROM_XANDR";
    ActivityType["DEACTIVATE_ORPHANED_LINE_ITEM_PUSH_TO_XANDR"] = "DEACTIVATE_ORPHANED_LINE_ITEM_PUSH_TO_XANDR";
    ActivityType["CAMPAIGN_POSITION_FAILED_PAYMENT_STATUS"] = "CAMPAIGN_POSITION_FAILED_PAYMENT_STATUS";
    ActivityType["CAMPAIGN_POSITION_OVERDUE_PAYMENT_RECEIVED"] = "CAMPAIGN_POSITION_OVERDUE_PAYMENT_RECEIVED";
    ActivityType["INVOICE_EXPORTED_TO_SAP"] = "INVOICE_EXPORTED_TO_SAP";
    ActivityType["RECEIPT_EXPORTED_TO_SAP"] = "RECEIPT_EXPORTED_TO_SAP";
    ActivityType["PAYMENT_CHARGED"] = "PAYMENT_CHARGED";
    ActivityType["DEPOSIT_CREATED"] = "DEPOSIT_CREATED";
    ActivityType["DEPOSIT_CANCELED"] = "DEPOSIT_CANCELED";
})(ActivityType || (ActivityType = {}));
export var ActivityEntityType;
(function (ActivityEntityType) {
    ActivityEntityType["CAMPAIGN"] = "CAMPAIGN";
    ActivityEntityType["CAMPAIGN_POSITION"] = "CAMPAIGN_POSITION";
    ActivityEntityType["CREATIVE"] = "CREATIVE";
    ActivityEntityType["INVOICE"] = "INVOICE";
    ActivityEntityType["PAYMENT"] = "PAYMENT";
})(ActivityEntityType || (ActivityEntityType = {}));
